import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'

export interface IFavoriteToggleProps {
  className?: string
  hasStarred: List<string>
  onToggleFavorite: (userId: string, isFavorite: boolean) => void
  showCount?: boolean
  style?: React.CSSProperties
}

type FavoriteToggleProps = IFavoriteToggleProps & ICurrentUserState

export class FavoriteToggle extends React.PureComponent<FavoriteToggleProps> {
  constructor(props: FavoriteToggleProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    const favoriteIcon: [IconPrefix, IconName] = this._isFavorite()
      ? ['fas', 'star']
      : ['far', 'star']

    return (
      <a
        className={this.props.className}
        onClick={this._onToggleFavorite}
        style={this.props.style}
        title='Favorite'
      >
        <FontAwesomeIcon icon={favoriteIcon} fixedWidth />
        {this.props.showCount && this.props.hasStarred.size > 0 && (
          <span>{this.props.hasStarred.size}</span>
        )}
      </a>
    )
  }

  private _isFavorite() {
    if (!this.props.user) {
      return false
    } else {
      return this.props.hasStarred.includes(this.props.user.id)
    }
  }

  private _onToggleFavorite() {
    if (this.props.user) {
      this.props.onToggleFavorite(this.props.user.id, !this._isFavorite())
    }
  }
}
